var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DwModalService } from 'ng-quicksilver';
import { FxLoingingService } from 'app/implementation/auth/fx-login.service';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { DwRoutingMessageService, DwNewRouteKeyService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { DefaultUrlSerializer } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/fx-http-client/http/fx-http-client";
import * as i2 from "../../../../../projects/webdpt/framework/components/dw-tab-routing/service/new-route-key.service";
import * as i3 from "@angular/router";
import * as i4 from "@ngx-translate/core";
import * as i5 from "../../../../../projects/webdpt/framework/components/message/routing-message.service";
import * as i6 from "../../auth/fx-login.service";
import * as i7 from "ng-quicksilver";
import * as i8 from "../../auth/fx-auth/fx-user-info.service";
var MallService = /** @class */ (function () {
    function MallService(http, router, routerA, route, translateService, dwMessage, fxLoingingService, dwModalService, fxUserService) {
        this.http = http;
        this.router = router;
        this.routerA = routerA;
        this.route = route;
        this.translateService = translateService;
        this.dwMessage = dwMessage;
        this.fxLoingingService = fxLoingingService;
        this.dwModalService = dwModalService;
        this.fxUserService = fxUserService;
        // 记录当前响应式平台
        this.fxMedia = window.innerWidth <= 590 ? 'mobile' : (window.innerWidth <= 1200 ? 'pad' : 'pc');
        this.eventEmit = new EventEmitter();
    }
    MallService.prototype.getDns = function (val, id) {
        //判断入参是否为空值
        if (val === null) {
            return;
        }
        //带id域名
        var urlId = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/, 
        //完整域名
        urlDns = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/, 
        //IP地址
        urlIp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/, 
        //省www域名
        urlNameDns = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/, 
        //以http或https开头
        urlHttp = /(http|https):\/\/([\w.]+\/?)\S*/;
        var hasHttp = new RegExp(urlHttp, 'i');
        if (urlHttp.test(val) === true) {
            var newLink = val.slice(7);
            window.open("http://" + newLink);
            return;
        }
        var checkedUrl = urlId || urlDns || urlIp || urlNameDns;
        var checkUrl = new RegExp(checkedUrl, 'i');
        var text = checkUrl.test(val);
        if (text === true) {
            window.open("http://" + val);
        }
        else {
            if (id == '') {
                this.router.navigate([val]);
            }
            else {
                this.router.navigate([val], { queryParams: { id: id } });
            }
        }
    };
    // 高级促销记录历程，赠品不写历程只有主品写历程，促销后价格记录主品的供价，叠加促销的历程记录是先记录一般促销再高级促销
    MallService.prototype.setHistoryDataSenior = function (dcdList, dccInfo, tableNo) {
        // 如果只有一般促销，或者只有高级促销则只有一层dcd，如果促销叠加了，那么dcd下面还会再有一个dcd
        if (dcdList && dcdList.length) {
            dcdList.forEach(function (s) {
                var _a;
                s[tableNo + '_f_list'] = []; // 每个促销主品记录一笔历程，如果叠加了促销则记录两笔
                var seq1 = 1; // 一般促销只有有一笔默认写死1，叠加了高级促销最多一笔为2
                // 判断是否有一般促销
                if (s.dcd_f_list && s.dcd_f_list.length) {
                    s.dcd_f_list.forEach(function (t) {
                        var _a;
                        s[tableNo + '_f_list'].push((_a = {},
                            _a[tableNo + 'seq1'] = seq1,
                            _a[tableNo + 'sprice'] = t.dansprice,
                            _a[tableNo + 'pdisc'] = t.dcc004 == '2' ? t.eab073 : '',
                            _a[tableNo + 'price'] = t.eabprice,
                            _a[tableNo + '001'] = t.dccdocno,
                            _a[tableNo + '002'] = t.dcdseq,
                            _a[tableNo + '003'] = t.dcc004,
                            _a[tableNo + '004'] = '',
                            _a));
                    });
                    seq1 += 1;
                }
                s[tableNo + '_f_list'].push((_a = {},
                    _a[tableNo + 'seq1'] = seq1,
                    _a[tableNo + 'sprice'] = s[tableNo + '_f_list'].length ? s[tableNo + '_f_list'][0][tableNo + 'price'] : s.dansprice,
                    _a[tableNo + 'pdisc'] = dccInfo.dcc004 == '2' ? dccInfo.dcc007 : '',
                    _a[tableNo + 'price'] = s.eabprice,
                    _a[tableNo + '001'] = s.dccdocno,
                    _a[tableNo + '002'] = s.dcdseq,
                    _a[tableNo + '003'] = dccInfo.dcc004,
                    _a[tableNo + '004'] = s.dcq001,
                    _a));
            });
        }
        return dcdList;
    };
    // 一般促销记录历程
    MallService.prototype.setHistoryDataBase = function (dcdList, tableNo) {
        // 一般促销加购或下单主品只有一笔
        if (dcdList && dcdList.length) {
            dcdList.forEach(function (s) {
                var _a;
                if ((s.edd004 || s.eab026) && (s.edd007 == '1' || s.eab024 == '1')) { // 从加购或下单的数据中获取到有促销且为主品的数据进行写历程
                    s[tableNo + '_f_list'] = [(_a = {},
                            _a[tableNo + 'seq1'] = 1,
                            _a[tableNo + 'sprice'] = s.dansprice,
                            _a[tableNo + 'pdisc'] = s.dcc004 == '2' ? s.eab073 : '',
                            _a[tableNo + 'price'] = s.eabprice,
                            _a[tableNo + '001'] = s.dccdocno,
                            _a[tableNo + '002'] = s.dcdseq,
                            _a[tableNo + '003'] = s.dcc004,
                            _a[tableNo + '004'] = '',
                            _a)];
                }
            });
        }
        return dcdList;
    };
    // 收藏/取消收藏
    MallService.prototype.updCollect = function (param) {
        var _this = this;
        return new Observable(function (observer) {
            if (_this.fxUserService.userInfo['c_tourist'] === 'Y') {
                if (_this.fxMedia && _this.fxMedia === 'mobile') {
                    //移动端跳转新的页面
                    _this.router.navigate(['mall/mobileLogin/mobileLogin'], { queryParams: { isShowHeaderBtn: 'N' } });
                }
                else {
                    _this.fxLoingingService.openLoginModal(_this.fxMedia);
                }
                observer.next(false);
                observer.complete();
                return;
            }
            _this.http.post('E/IFxed020Service/updCollect', { 'param': param }).subscribe(function (response) {
                if (response.success) {
                    var msg = param.type === 'del' ? 'fxed020-取消收藏成功' : 'fxed020-收藏成功';
                    _this.dwMessage.success(_this.translateService.instant(msg));
                    observer.next(true);
                    observer.complete();
                }
                else {
                    _this.dwMessage.error(response.message);
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    };
    // 加购物车
    MallService.prototype.addShoppingCart = function (param) {
        var _this = this;
        return new Observable(function (observer) {
            if (_this.fxUserService.userInfo['c_tourist'] === 'Y') {
                if (_this.fxMedia && _this.fxMedia === 'mobile') {
                    //移动端跳转新的页面
                    _this.router.navigate(['mall/mobileLogin/mobileLogin'], { queryParams: { isShowHeaderBtn: 'N' } });
                }
                else {
                    _this.fxLoingingService.openLoginModal(_this.fxMedia);
                }
                observer.next(false);
                observer.complete();
                return;
            }
            _this.http.post('E/ISaleService/addShoppingCart', { 'param': param }).subscribe(function (response) {
                if (response.success) {
                    _this.dwMessage.success(_this.translateService.instant('fxed020-成功加入购物车'));
                    observer.next(true);
                    observer.complete();
                }
                else {
                    _this.dwMessage.error(response.message);
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    };
    // 跳转购物车
    MallService.prototype.openShoppingCart = function (id) {
        if (this.fxUserService.userInfo['c_tourist'] == 'Y') {
            if (this.fxMedia && this.fxMedia === 'mobile') {
                //移动端跳转新的页面
                this.router.navigate(['mall/mobileLogin/mobileLogin'], { queryParams: { isShowHeaderBtn: 'N' } });
            }
            else {
                this.fxLoingingService.openLoginModal(this.fxMedia);
            }
        }
        else {
            if (this.fxMedia && this.fxMedia === 'mobile') {
                this.router.navigate(['mall/shopping-cart'], { queryParams: { type: id, isShowHeaderBtn: 'N' } });
            }
            else {
                this.router.navigate(['mall/shopping-cart'], { queryParams: { type: id } });
            }
        }
    };
    // 获取费用抵扣数据
    MallService.prototype.getExpenseInfo = function (param) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('G/IGCommonService/getExpenseInfo', { 'param': param }).subscribe(function (response) {
                if (response.success && response.data && response.data.length) {
                    observer.next(response.data);
                    observer.complete();
                }
                else {
                    observer.next([]);
                    observer.complete();
                }
            });
        });
    };
    MallService.prototype.checkQtyCorrect = function (item) {
        var flag = true;
        // 商品不可小于最小订购量
        if (Number(item.qty) < Number(item.productPromotionMinimumQuantity || 0)) {
            this.dwMessage.warning(this.translateService.instant('fxed020-minqty-error2'));
            flag = false;
        }
        // 商品不可大于最大订购量
        if (Number(item.productPromotionMaximumQuantity || 0) > 0 && Number(item.qty) > Number(item.productPromotionMaximumQuantity || 0)) {
            this.dwMessage.warning(this.translateService.instant('fxed020-maxqty-error'));
            flag = false;
        }
        return flag;
    };
    // 解决url没有变化路由不刷新问题
    MallService.prototype.getQueryParams = function () {
        return window.location.href.indexOf('ent=') == -1 ? { queryParams: { ent: this.fxUserService.userInfo['c_ent'] } } : {};
    };
    // 判断文件类型是图片还是视频
    MallService.prototype.getMediumType = function (str) {
        var res = str ? str.toLowerCase() : '';
        if (res.indexOf('mp4') !== -1 || res.indexOf('webm') !== -1 || res.indexOf('ogg') !== -1) {
            return 'video';
        }
        else {
            return 'image';
        }
    };
    // 刷新当前路由
    MallService.prototype.reloadCurrentUrl = function () {
        var _this = this;
        var entParam = window.location.href.indexOf('ent=') == -1 ? { ent: this.fxUserService.userInfo['c_ent'] } : {};
        var currentUrl = this.routerA.url.split('?')[0];
        this.getUrlParams().subscribe(function (res) {
            var queryParams = res;
            queryParams = Object.assign(queryParams, entParam);
            queryParams.isCurrentPage = 'Y';
            _this.router.navigate([currentUrl], { queryParams: queryParams });
        });
    };
    // 获取url参数
    MallService.prototype.getUrlParams = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.route.queryParams.subscribe(function (params) {
                var queryParams = JSON.parse(JSON.stringify(params));
                observer.next(queryParams);
                observer.complete();
            });
        });
    };
    MallService.ngInjectableDef = i0.defineInjectable({ factory: function MallService_Factory() { return new MallService(i0.inject(i1.FxDapHttpClient), i0.inject(i2.DwNewRouteKeyService), i0.inject(i3.Router), i0.inject(i3.ActivatedRoute), i0.inject(i4.TranslateService), i0.inject(i5.DwRoutingMessageService), i0.inject(i6.FxLoingingService), i0.inject(i7.DwModalService), i0.inject(i8.FxUserInfoService)); }, token: MallService, providedIn: "root" });
    return MallService;
}());
export { MallService };
// url序列化
var CustomUrlSerializer = /** @class */ (function (_super) {
    __extends(CustomUrlSerializer, _super);
    function CustomUrlSerializer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomUrlSerializer.prototype.parse = function (url) {
        return _super.prototype.parse.call(this, decodeURIComponent(url));
    };
    CustomUrlSerializer.prototype.serialize = function (tree) {
        return _super.prototype.serialize.call(this, tree).replace(/%3/g, '?').replace(/%3D/g, '=');
    };
    return CustomUrlSerializer;
}(DefaultUrlSerializer));
export { CustomUrlSerializer };
